/**
 * The profile page's tabs, and the `?tab=` links the account menu uses to
 * open one directly.
 */
export type ProfileTabKey = 'trips' | 'saved' | 'preferences' | 'settings';

export const PROFILE_TABS: { key: ProfileTabKey; label: string }[] = [
    { key: 'trips', label: 'Trips' },
    { key: 'saved', label: 'Saved' },
    { key: 'preferences', label: 'Preferences' },
    { key: 'settings', label: 'Settings' },
];

/** The tab named in a location's `?tab=`, or null when there is none or it isn't a real tab. */
export const profileTabFromSearch = (search: string): ProfileTabKey | null => {
    const tab = new URLSearchParams(search).get('tab');
    return PROFILE_TABS.find((entry) => entry.key === tab)?.key ?? null;
};

export const profileTabPath = (tab: ProfileTabKey) => `/profile?tab=${tab}`;
